import EmptyLayout from "@/layout/EmptyLayer";

const BetaRouter = {
  path: "/beta",
  name: "Beta",
  redirect: "/beta/profile",
  component: EmptyLayout,
  children: [
    {
      path: "profile",
      name: "BetaProfile",
      component: () => import("@/views/Profile/BetaHome.vue"),
      meta: {
        user: true,
      }, 
    },  
    {
      path: "faq-page",
      name: "FAQPage",
      component: () => import("@/views/FAQ"),
      meta: {
        user: true,
      }, 
    },

    {
      path: "news-list",
      name: "NewsList",
      component: () => import("@/views/Profile/NewsPage.vue"),
      meta: {
        user: true,
      },
    },
    {
      path: "news-details",
      name: "NewsDetails",
      component: () => import("@/views/Profile/NewsDetail.vue"),
      meta: {
        user: true,
      },
    },

    {
      path: `/universities/`,
      name: "PartnersUniversities",
      component: () => import("@/views/Profile/PartnerUniversity.vue"),
    },
  ],
};

export default BetaRouter;
